import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';

import { CartContextProvider } from '@/contexts/CartContext';

import { Signin } from './Signin';

const ErrorFallback = () => {
    return <div className="">loading</div>;
};

const SignInApp = () => {
    const client = new QueryClient({
        defaultOptions: {
            queries: {
                cacheTime: 1000 * 60 * 60 * 24, // 24 hours
                staleTime: Infinity,
            },
        },
    });
    const persister = createSyncStoragePersister({
        storage: window.localStorage,
    });

    return (
        <ErrorBoundary FallbackComponent={ErrorFallback}>
            <PersistQueryClientProvider client={client} persistOptions={{ persister }}>
                <ReactQueryDevtools initialIsOpen={false} />
                <CartContextProvider value={{ cartData: null }}>
                    <Signin />
                </CartContextProvider>
            </PersistQueryClientProvider>
        </ErrorBoundary>
    );
};

const id = 'sign-in';
const element = document.getElementById(id);
const root = ReactDOM.createRoot(element);
if (element) {
    root.render(
        <React.StrictMode>
            <SignInApp />
        </React.StrictMode>,
    );
}
